var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable jsdoc/require-returns */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable jsdoc/require-param */
/* eslint-disable valid-jsdoc */
import { Component, Complex, NotifyPropertyChanges, Property } from '@syncfusion/ej2-base';
import { isNullOrUndefined, Browser } from '@syncfusion/ej2-base';
import { createElement, remove, Event, EventHandler } from '@syncfusion/ej2-base';
import { createSvg, RectOption, measureText, TextOption, renderTextElement } from '../smithchart/utils/helper';
import { removeElement, textTrim } from '../smithchart/utils/helper';
import { SmithchartRect } from '../smithchart/utils/utils';
import { SmithchartMargin, SmithchartBorder, SmithchartFont } from '../smithchart/utils/utils';
import { getThemeColor } from '../smithchart/model/theme';
import { SmithchartLegendSettings } from '../smithchart/legend/legend';
import { SmithchartAxis } from '../smithchart/axis/axis';
import { Title } from '../smithchart/title/title';
import { SmithchartSeries } from '../smithchart/series/series';
import { AreaBounds } from '../smithchart/utils/area';
import { AxisRender } from '../smithchart/axis/axisrender';
import { SeriesRender } from '../smithchart/series/seriesrender';
import { Collection } from '@syncfusion/ej2-base';
import { getSeriesColor } from '../smithchart/model/theme';
import { ExportUtils } from '../smithchart/utils/export';
import { titleRender, subtitleRender, load, loaded } from '../smithchart/model/constant';
/**
 * Represents the Smithchart control.
 * ```html
 * <div id="smithchart"/>
 * <script>
 *   var chartObj = new Smithchart({ isResponsive : true });
 *   chartObj.appendTo("#smithchart");
 * </script>
 * ```
 */
let Smithchart = class Smithchart extends Component {
    /**
     * Constructor for creating the Smithchart widget
     */
    constructor(options, element) {
        super(options, element);
    }
    /**
     * Get component name
     */
    getModuleName() {
        return 'smithchart';
    }
    /**
     * Get the properties to be maintained in the persisted state.
     *
     * @private
     */
    getPersistData() {
        return '';
    }
    /**
     * Method to create SVG element.
     */
    createChartSvg() {
        this.removeSvg();
        createSvg(this);
    }
    renderTitle(title, type, groupEle) {
        const font = title.font ? title.font : title.textStyle;
        let textSize = measureText(title.text, font);
        let x;
        const textAlignment = title.textAlignment;
        let titleText = title.text;
        const maxTitleWidth = (isNullOrUndefined(title.maximumWidth)) ?
            Math.abs(this.margin.left + this.margin.right - (this.availableSize.width)) :
            title.maximumWidth;
        const titleWidthEnable = textSize.width > maxTitleWidth ? true : false;
        if (textSize.width > this.availableSize.width) {
            x = this.margin.left + this.border.width;
        }
        else {
            x = textAlignment === 'Center' ? (this.availableSize.width / 2 - textSize['width'] / 2) :
                (textAlignment === 'Near' ? (this.margin.left + this.elementSpacing + this.border.width) : (this.availableSize.width
                    - textSize['width'] - (this.margin.right + this.elementSpacing + this.border.width)));
        }
        const y = this.margin.top + textSize['height'] / 2 + this.elementSpacing;
        if (title.enableTrim && titleWidthEnable) {
            titleText = textTrim(maxTitleWidth, title.text, font);
            textSize = measureText(titleText, font);
        }
        groupEle = this.renderer.createGroup({ id: this.element.id + '_Title_Group' });
        const titleEventArgs = {
            text: titleText,
            x: x,
            y: y,
            name: titleRender,
            cancel: false
        };
        let options;
        const titleRenderSuccess = (args) => {
            if (!args.cancel) {
                options = new TextOption(this.element.id + '_Smithchart_' + type, args.x, args.y, 'start', args.text);
                font.fontFamily = this.themeStyle.fontFamily || title.textStyle.fontFamily;
                font.size = this.themeStyle.fontSize || title.textStyle.size;
                const element = renderTextElement(options, font, this.themeStyle.chartTitle, groupEle);
                element.setAttribute('tabindex', '0');
                const titleLocation = { x: args.x, y: args.y, textSize: textSize };
                this.svgObject.appendChild(groupEle);
                if (title.subtitle.text !== '' && title.subtitle.visible) {
                    this.renderSubtitle(title, type, textSize, this.availableSize, titleLocation, groupEle);
                }
            }
        };
        titleRenderSuccess.bind(this);
        this.trigger(titleRender, titleEventArgs, titleRenderSuccess);
    }
    renderSubtitle(title, type, textSize, size, titleLocation, groupEle) {
        const font = title.subtitle.textStyle;
        const subTitle = title.subtitle;
        const subTitleSize = measureText(subTitle.text, font);
        let subTitleText = subTitle.text;
        const maxSubTitleWidth = isNullOrUndefined(subTitle.maximumWidth) ?
            (this.bounds.width * 0.75) : subTitle.maximumWidth;
        if (subTitle.enableTrim && subTitleSize.width > maxSubTitleWidth) {
            subTitleText = textTrim(maxSubTitleWidth, subTitle.text, font);
        }
        const x = title['subtitle'].textAlignment === 'Far' ? (titleLocation.x + (titleLocation.textSize.width)) :
            (title['subtitle'].textAlignment === 'Near') ? titleLocation.x :
                (titleLocation.x + (titleLocation.textSize.width / 2));
        const y = titleLocation.y + (2 * this.elementSpacing);
        const textAnchor = title['subtitle'].textAlignment === 'Far' ? 'end' :
            (title['subtitle'].textAlignment === 'Near') ? 'start' : 'middle';
        const subtitleEventArgs = {
            text: subTitleText,
            x: x,
            y: y,
            name: subtitleRender,
            cancel: false
        };
        const subtitleRenderSuccess = (args) => {
            if (!args.cancel) {
                const options = new TextOption(this.element.id + '_Smithchart_' + type, args.x, args.y, textAnchor, args.text);
                const element = renderTextElement(options, font, this.themeStyle.chartTitle, groupEle);
                element.setAttribute('aria-label', subTitle.description || args.text);
                groupEle.appendChild(element);
            }
        };
        subtitleRenderSuccess.bind(this);
        this.trigger(subtitleRender, subtitleEventArgs, subtitleRenderSuccess);
    }
    /**
     * Render the smithchart border
     *
     * @private
     */
    renderBorder() {
        const border = this.border;
        this.background = this.background ? this.background : this.themeStyle.background;
        const borderRect = new RectOption(this.element.id + '_SmithchartBorder', this.background, border, 1, new SmithchartRect(border.width / 2, border.width / 2, this.availableSize.width - border.width, this.availableSize.height - border.width));
        const element = this.svgObject.appendChild(this.renderer.drawRectangle(borderRect));
        element.setAttribute('aria-hidden', 'true');
    }
    /**
     * Called internally if any of the property value changed.
     *
     * @private
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onPropertyChanged(newProp, oldProp) {
        let renderer = false;
        for (const prop of Object.keys(newProp)) {
            switch (prop) {
                case 'background':
                case 'border':
                case 'series':
                case 'legendSettings':
                case 'radius':
                    renderer = true;
                    break;
                case 'size':
                    this.createChartSvg();
                    renderer = true;
                    break;
                case 'theme':
                case 'renderType':
                    this.animateSeries = true;
                    renderer = true;
                    break;
            }
        }
        if (renderer) {
            this.render();
        }
    }
    /**
     * Initialize the event handler.
     */
    preRender() {
        this.allowServerDataBinding = false;
        this.trigger(load, { smithchart: this });
        this.unWireEVents();
        this.initPrivateVariable();
        this.wireEVents();
    }
    initPrivateVariable() {
        this.animateSeries = true;
        this.element.setAttribute('role', 'region');
        this.element.setAttribute('aria-label', this.title.description || this.title.text);
        this.element.setAttribute('tabindex', '0');
    }
    /**
     * To Initialize the control rendering.
     */
    setTheme() {
        /*! Set theme */
        this.themeStyle = getThemeColor(this.theme);
        this.seriesColors = getSeriesColor(this.theme);
        // let count: number = colors.length;
        // for (let i: number = 0; i < this.series.length; i++) {
        //     this.series[i].fill = this.series[i].fill ? this.series[i].fill : colors[i % count];
        // }
    }
    render() {
        this.createChartSvg();
        this.element.appendChild(this.svgObject);
        this.setTheme();
        this.createSecondaryElement();
        this.renderBorder();
        if (this.smithchartLegendModule && this.legendSettings.visible) {
            this.legendBounds = this.smithchartLegendModule.renderLegend(this);
        }
        this.legendBounds = this.legendBounds ? this.legendBounds : { x: 0, y: 0, width: 0, height: 0 };
        const areaBounds = new AreaBounds();
        this.bounds = areaBounds.calculateAreaBounds(this, this.title, this.legendBounds);
        if (this.title.text !== '' && this.title.visible) {
            this.renderTitle(this.title, 'title', null);
        }
        const axisRender = new AxisRender();
        axisRender.renderArea(this, this.bounds);
        this.seriesrender = new SeriesRender();
        this.seriesrender.draw(this, axisRender, this.bounds);
        this.renderComplete();
        this.allowServerDataBinding = true;
        this.trigger(loaded, { smithchart: this });
    }
    createSecondaryElement() {
        if (isNullOrUndefined(document.getElementById(this.element.id + '_Secondary_Element'))) {
            const secondaryElement = createElement('div', {
                id: this.element.id + '_Secondary_Element',
                styles: 'z-index:1;'
            });
            this.element.appendChild(secondaryElement);
            const rect = this.element.getBoundingClientRect();
            const svgRect = document.getElementById(this.element.id + '_svg');
            if (svgRect) {
                const svgClientRect = svgRect.getBoundingClientRect();
                secondaryElement.style.left = Math.max(svgClientRect.left - rect.left, 0) + 'px';
                secondaryElement.style.top = Math.max(svgClientRect.top - rect.top, 0) + 'px';
            }
        }
        else {
            removeElement(this.element.id + '_Secondary_Element');
        }
    }
    /**
     * To destroy the widget
     *
     * @returns {void}.
     */
    destroy() {
        if (this.element) {
            this.unWireEVents();
            super.destroy();
            this.element.classList.remove('e-smithchart');
            this.removeSvg();
            this.svgObject = null;
        }
    }
    /**
     * To bind event handlers for smithchart.
     */
    wireEVents() {
        EventHandler.add(this.element, 'click', this.smithchartOnClick, this);
        EventHandler.add(this.element, Browser.touchMoveEvent, this.mouseMove, this);
        EventHandler.add(this.element, Browser.touchEndEvent, this.mouseEnd, this);
        window.addEventListener((Browser.isTouch && ('orientation' in window && 'onorientationchange' in window)) ? 'orientationchange' : 'resize', this.smithchartOnResize.bind(this));
    }
    mouseMove(e) {
        if (e.type === 'touchmove') {
            this.isTouch = true;
        }
        else {
            this.isTouch = e.pointerType === 'touch' || e.pointerType === '2' || this.isTouch;
        }
        if (this.tooltipRenderModule && !this.isTouch) {
            this.tooltipRenderModule.smithchartMouseMove(this, e);
        }
    }
    mouseEnd(e) {
        if (e.type === 'touchend') {
            this.isTouch = true;
        }
        else {
            this.isTouch = e.pointerType === 'touch' || e.pointerType === '2';
        }
        if (this.tooltipRenderModule && this.isTouch) {
            const tooltipElement = this.tooltipRenderModule.smithchartMouseMove(this, e);
            if (tooltipElement) {
                this.fadeoutTo = +setTimeout(() => {
                    tooltipElement.fadeOut();
                }, 2000);
            }
        }
    }
    /**
     * To handle the click event for the smithchart.
     */
    smithchartOnClick(e) {
        const targetEle = e.target;
        const targetId = targetEle.id;
        const parentElement = document.getElementById(targetId).parentElement;
        const grpElement = document.getElementById(parentElement.id).parentElement;
        if (grpElement.id === 'containerlegendItem_Group' && this.legendSettings.toggleVisibility) {
            const childElement = parentElement.childNodes[1];
            const circleElement = parentElement.childNodes[0];
            const legendText = childElement.textContent;
            let seriesIndex;
            let fill;
            for (let i = 0; i < this.smithchartLegendModule.legendSeries.length; i++) {
                if (legendText === this.smithchartLegendModule.legendSeries[i]['text']) {
                    seriesIndex = this.smithchartLegendModule.legendSeries[i].seriesIndex;
                    fill = this.smithchartLegendModule.legendSeries[i].fill;
                }
            }
            const seriesElement = document.getElementById(this.element.id + '_svg' + '_seriesCollection' + seriesIndex);
            if (seriesElement.getAttribute('visibility') === 'visible') {
                circleElement.setAttribute('fill', 'gray');
                seriesElement.setAttribute('visibility', 'hidden');
                this.series[seriesIndex].visibility = 'hidden';
            }
            else {
                circleElement.setAttribute('fill', fill);
                seriesElement.setAttribute('visibility', 'visible');
                this.series[seriesIndex].visibility = 'visible';
            }
        }
    }
    /**
     * To unbind event handlers from smithchart.
     */
    unWireEVents() {
        EventHandler.remove(this.element, 'click', this.smithchartOnClick);
        EventHandler.remove(this.element, Browser.touchMoveEvent, this.mouseMove);
        EventHandler.remove(this.element, Browser.touchEndEvent, this.mouseEnd);
        window.removeEventListener((Browser.isTouch && ('orientation' in window && 'onorientationchange' in window)) ? 'orientationchange' : 'resize', this.smithchartOnResize);
    }
    print(id) {
        const exportChart = new ExportUtils(this);
        exportChart.print(id);
    }
    /**
     * Handles the export method for chart control.
     */
    export(type, fileName, orientation) {
        const exportMap = new ExportUtils(this);
        exportMap.export(type, fileName, orientation);
    }
    /**
     * To handle the window resize event on smithchart.
     */
    smithchartOnResize() {
        this.animateSeries = false;
        if (this.resizeTo) {
            clearTimeout(this.resizeTo);
        }
        this.resizeTo = +setTimeout(() => {
            this.render();
        }, 500);
        return false;
    }
    /**
     * To provide the array of modules needed for smithchart rendering
     *
     * @private
     */
    requiredModules() {
        const modules = [];
        if (this.legendSettings.visible) {
            modules.push({
                member: 'SmithchartLegend',
                args: [this]
            });
        }
        for (let i = 0; i < this.series.length; i++) {
            if (this.series[i].tooltip.visible) {
                modules.push({
                    member: 'TooltipRender',
                    args: [this]
                });
                break;
            }
        }
        return modules;
    }
    /**
     * To Remove the SVG.
     *
     * @private
     */
    removeSvg() {
        removeElement(this.element.id + '_Secondary_Element');
        const removeLength = 0;
        if (this.svgObject) {
            while (this.svgObject.childNodes.length > removeLength) {
                this.svgObject.removeChild(this.svgObject.firstChild);
            }
            if (!this.svgObject.hasChildNodes() && this.svgObject.parentNode) {
                remove(this.svgObject);
            }
        }
    }
};
__decorate([
    Property('Impedance')
], Smithchart.prototype, "renderType", void 0);
__decorate([
    Property('')
], Smithchart.prototype, "width", void 0);
__decorate([
    Property('')
], Smithchart.prototype, "height", void 0);
__decorate([
    Property('Material')
], Smithchart.prototype, "theme", void 0);
__decorate([
    Complex({}, SmithchartMargin)
], Smithchart.prototype, "margin", void 0);
__decorate([
    Complex({}, SmithchartFont)
], Smithchart.prototype, "font", void 0);
__decorate([
    Complex({}, SmithchartBorder)
], Smithchart.prototype, "border", void 0);
__decorate([
    Complex({}, Title)
], Smithchart.prototype, "title", void 0);
__decorate([
    Collection([{}], SmithchartSeries)
], Smithchart.prototype, "series", void 0);
__decorate([
    Complex({}, SmithchartLegendSettings)
], Smithchart.prototype, "legendSettings", void 0);
__decorate([
    Complex({}, SmithchartAxis)
], Smithchart.prototype, "horizontalAxis", void 0);
__decorate([
    Complex({}, SmithchartAxis)
], Smithchart.prototype, "radialAxis", void 0);
__decorate([
    Property(null)
], Smithchart.prototype, "background", void 0);
__decorate([
    Property(10)
], Smithchart.prototype, "elementSpacing", void 0);
__decorate([
    Property(1)
], Smithchart.prototype, "radius", void 0);
__decorate([
    Event()
], Smithchart.prototype, "beforePrint", void 0);
__decorate([
    Event()
], Smithchart.prototype, "animationComplete", void 0);
__decorate([
    Event()
], Smithchart.prototype, "load", void 0);
__decorate([
    Event()
], Smithchart.prototype, "loaded", void 0);
__decorate([
    Event()
], Smithchart.prototype, "legendRender", void 0);
__decorate([
    Event()
], Smithchart.prototype, "titleRender", void 0);
__decorate([
    Event()
], Smithchart.prototype, "subtitleRender", void 0);
__decorate([
    Event()
], Smithchart.prototype, "textRender", void 0);
__decorate([
    Event()
], Smithchart.prototype, "axisLabelRender", void 0);
__decorate([
    Event()
], Smithchart.prototype, "seriesRender", void 0);
__decorate([
    Event()
], Smithchart.prototype, "tooltipRender", void 0);
Smithchart = __decorate([
    NotifyPropertyChanges
], Smithchart);
export { Smithchart };
